import { IDataProxy } from "./types";
import { ajax } from "./ajax";

export class DataProxy implements IDataProxy {
	public url: string;
	constructor(url: string) {
		this.url = url;
	}
	load<T=string>(): Promise<T> {
		return ajax.get(this.url);
	}
	save(data: any, mode: string): Promise<any> {
		switch (mode) {
			case "delete":
				return ajax.delete(this.url, data);
			case "update":
			case "insert":
			default: return ajax.post(this.url, data);
		}
	}
}